import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { getData, getFile } from "features/dinamic";
import { setLoading } from "features/loader";
import { setVisible } from "features/modal";
import { setDataToast, setVisibleToast } from "features/toast";
import AlertInterface from "features/toast/toastInterface";
import saveAs from "file-saver";

interface CalificacionState {
  status: string;
  error: string;
  entregas: any[];
  entrega: any;
  tareaContext: any | null;
}

const initialState: CalificacionState = {
  status: 'idle',
  error: '',
  entregas: [],
  entrega: null,
  tareaContext: null,
}

export const fetchEntregasTarea = createAsyncThunk('calificacion/fetchEntregasTarea', async ({ idTareaSesion, page, pageSize }: any, { dispatch, getState, rejectWithValue }) => {
  const idsp = 131;
  const { result, message, data } = await getData({ idsp, idTareaSesion, page, pageSize }, getState, dispatch);
  if (result) {
    return { data };
  }
  return rejectWithValue(message);
});

export const calificarTarea = createAsyncThunk('calificacion/calificarTarea', async ({ calificacion, observaciones }: any, { dispatch, getState, rejectWithValue }) => {
  const state: any = getState();
  const entrega = selectEntrega(state);
  const idsp = 132;
  let alert: AlertInterface;

  const { result, message, data } = await getData({ idsp, idTareaAlumno: entrega?.idTareaAlumno, calificacion, observaciones }, getState, dispatch);
  if (result) {
    alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
  }
  else {
    alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
  }
  dispatch(setDataToast(alert));
  dispatch(setVisibleToast(true));
  if (result) {
    dispatch(setVisible(false));
    // refrescar lista actual
    const idTareaSesion = entrega?.idTareaSesion;
    if (idTareaSesion) {
      dispatch(fetchEntregasTarea({ idTareaSesion }));
    }
  }
  dispatch(setLoading(false));
  setTimeout(() => {
    dispatch(setVisibleToast(false));
  }, 4000);
  return rejectWithValue(message);
});

export const fetchTareaContext = createAsyncThunk('calificacion/fetchTareaContext', async ({ idTareaSesion }: any, { dispatch, getState, rejectWithValue }) => {
  const idsp = 136;
  const { result, message, data } = await getData({ idsp, idTareaSesion }, getState, dispatch);
  if (result) {
    return { data };
  }
  return rejectWithValue(message);
});

export const downloadEntrega = createAsyncThunk('calificacion/downloadEntrega', async (_: any, { dispatch, getState, rejectWithValue }) => {
  const state: any = getState();
  const entrega = selectEntrega(state);
  let alert: AlertInterface;
  if (entrega?.fileUrlEntrega) {
    const fileExtension = entrega.fileUrlEntrega.substring(entrega.fileUrlEntrega.lastIndexOf('.'));
    const nombre = entrega?.nombreArchivo || 'entrega';
    const fileName = `${nombre}${fileExtension}`;
    const response = await getFile({ fileUrl: entrega.fileUrlEntrega, fileName });
    if (response && response.blob) {
      saveAs(response.blob, fileName);
      alert = { title: 'CORRECTO..!', message: 'ARCHIVO DESCARGADO CORRECTAMENTE', data: [], type: 'LimeGreen', time: Date.now() };
    } else {
      alert = { title: 'ACCIÓN INCOMPLETA', message: 'ARCHIVO NO DISPONIBLE', data: [], type: 'Crimson', time: Date.now() };
    }
  } else {
    alert = { title: 'ACCIÓN INCOMPLETA', message: 'ARCHIVO NO DISPONIBLE', data: [], type: 'Crimson', time: Date.now() };
  }
  dispatch(setDataToast(alert));
  dispatch(setVisibleToast(true));
  dispatch(setLoading(false));
  setTimeout(() => {
    dispatch(setVisibleToast(false));
  }, 4000);
});

export const calificacionSlice = createSlice({
  name: 'calificacion',
  initialState,
  reducers: {
    setEntregas: (state, action) => {
      state.entregas = action.payload || [];
    },
    setEntrega: (state, action) => {
      state.entrega = !action.payload ? initialState.entrega : action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchEntregasTarea.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchEntregasTarea.fulfilled, (state, action) => {
        const { data } = action.payload as any;
        state.status = 'completed';
        state.entregas = data ? data : [];
      })
      .addCase(fetchEntregasTarea.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
      })
      .addCase(fetchTareaContext.fulfilled, (state, action) => {
        const data = action.payload?.data;
        if (Array.isArray(data) && data.length > 0) {
          state.tareaContext = data[0];
        } else if (data && !Array.isArray(data)) {
          state.tareaContext = data;
        } else {
          state.tareaContext = null;
        }
      })
  }
});

export const selectEntregas = (state: RootState) => state.calificacion.entregas;
export const selectEntrega = (state: RootState) => state.calificacion.entrega;
export const selectTareaContext = (state: RootState) => state.calificacion.tareaContext;

export const { setEntregas, setEntrega } = calificacionSlice.actions;

export default calificacionSlice.reducer;
